import { render, staticRenderFns } from "./ApplicantList.vue?vue&type=template&id=ffb5f6c8&scoped=true&"
import script from "./ApplicantList.vue?vue&type=script&lang=js&"
export * from "./ApplicantList.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ApplicantList.vue?vue&type=style&index=1&id=ffb5f6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb5f6c8",
  null
  
)

export default component.exports